import React, { useRef, useEffect, useState } from 'react'
import hamburgerIcon from '../../images/hamburger.svg'
import exitIcon from '../../images/exit-white-circle.svg'
import searchIcon from '../../images/search-icon-white.svg'
import { getLinkPathname } from './helper'
import Logo from '../Logo/Logo'
import { Link } from '../global'

import './navigation.scss'

/**
 * Represents a desktop navigation menu with optional features.
 *
 * @param {boolean} props.isAkutrutaActive - Indicates whether the "Akutruta" feature is active.
 * @param {Array} props.menu - An array of menu items with labels and URLs.
 * @returns {JSX.Element} A React component for the desktop navigation menu.
 */
export const DesktopMenu = ({ isAkutrutaActive, menu, logoSrc }) => {
  const [open, setOpen] = useState(false)
  const menuRef = useRef(null)
  const buttonRef = useRef(null)
  const pathname = typeof window !== 'undefined' && window.location.pathname

  useEffect(() => {
    if (document) {
      // Function to handle clicks outside of the menu
      function handleClickOutside(event) {
        if (
          menuRef.current &&
          !menuRef.current.contains(event.target) &&
          !buttonRef.current.contains(event.target)
        ) {
          setOpen(false)
        }
      }

      document.addEventListener('mousedown', handleClickOutside)

      return () => {
        document.removeEventListener('mousedown', handleClickOutside)
      }
    }
  }, [])

  return (
    <div className="desktop-menu">
      <button
        ref={buttonRef}
        className="icon-button no-padding-right"
        onClick={() => setOpen(!open)}
      >
        <img src={hamburgerIcon} alt="Hamburger icon" />
      </button>

      <div
        ref={menuRef}
        className={`secondary-menu ${(open && 'active') || 'hidden'}`}
        data-akutrutan={isAkutrutaActive}
      >
        <div className="icon-bar">
          <Link to="/sok" style={{ fontSize: 0 }}>
            <img src={searchIcon} alt="search icon" />
          </Link>
          <button className="icon-button" onClick={() => setOpen(!open)}>
            <img src={exitIcon} alt="exit icon" />
          </button>
        </div>
        <ul>
          {menu?.map((link, index) => (
            <Link
              className={`nav-link${
                (getLinkPathname(link) === pathname && '__active') || ''
              } desktop-link`}
              to={link.path}
              key={index}
            >
              {link.label}
            </Link>
          ))}
        </ul>
        <div className="image-container">
          <Link to="/">
            <Logo src={logoSrc} height="46px" />
          </Link>
        </div>
      </div>
    </div>
  )
}
